import '@fontsource-variable/outfit';
import '@fontsource-variable/dm-sans';
import { createHead } from '@unhead/vue/client';
import { createPokerApp } from './app';
import { loadTagManager } from './lib/analytics';

const root = document.getElementById('app')!;
const hydrate = root.hasAttribute('data-prerendered');
const { app, router } = createPokerApp({ ssr: false, hydrate, head: createHead() });

loadTagManager();

router.isReady().then(() => {
  app.mount(root);
  root.removeAttribute('data-prerendered');
});

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
